<template>
  <WaggonInfoBody
    :color="work_package.color"
    :textcolor="work_package.textcolor"
    >
    <template #buttons>
        <v-btn
          @click="
          backlog?
          createUObject({
            url: [
              {projects: project_id},
              {wbgroups: $route.params.wbgroup_id},
              {wblines: $route.params.wbline_id},
              {wbworkpackages: ''},
              {showWithEntitiesNormalized: ''}
            ],
            u_object: Object.assign(
              JSON.parse(JSON.stringify(work_package)),
              {[`${prefix}wworksteps`]: getWBObjects({type: `${prefix}wworksteps`, ids: work_package[`${prefix}wworksteps`]})},
              {[`${prefix}wdefectsteps`]: getWBObjects({type: `${prefix}wdefectsteps`, ids: work_package[`${prefix}wdefectsteps`]})},
              {[`${prefix}wqualitysteps`]: getWBObjects({type: `${prefix}wqualitysteps`, ids: work_package[`${prefix}wqualitysteps`]})},
              {[`${prefix}whandoversteps`]: getWBObjects({type: `${prefix}whandoversteps`, ids: work_package[`${prefix}whandoversteps`]})},
              {[`${prefix}wdesignsteps`]: getWBObjects({type: `${prefix}wdesignsteps`, ids: work_package[`${prefix}wdesignsteps`]})},
              {[`${prefix}wlogisticsteps`]: getWBObjects({type: `${prefix}wlogisticsteps`, ids: work_package[`${prefix}wlogisticsteps`]})},
              {[`${prefix}wmaterialsteps`]: getWBObjects({type: `${prefix}wmaterialsteps`, ids: work_package[`${prefix}wmaterialsteps`]})},
              {[`${prefix}wmachinesteps`]: getWBObjects({type: `${prefix}wmachinesteps`, ids: work_package[`${prefix}wmachinesteps`]})},
              {position: $store.state.ProjectBacklog.new_wp_position?$store.state.ProjectBacklog.new_wp_position:-1},
            )
            }).then((payload) => {
                $router.push({
                  name: 'TaktPlanBacklogs',
                  })
              })
          :
          requestSnackbarCreate({
            url: [
              {projects: project_id},
              {trains: train_id},
              {taktareas: taktarea_id},
              {twaggons: twaggon_id},
              {tworkpackages: ''},
              {showWithEntitiesNormalized: ''}
            ],
            u_object: Object.assign(
              JSON.parse(JSON.stringify(work_package)),
              {[`${prefix}wworksteps`]: getWBObjects({type: `${prefix}wworksteps`, ids: work_package[`${prefix}wworksteps`]})},
              {[`${prefix}wdefectsteps`]: getWBObjects({type: `${prefix}wdefectsteps`, ids: work_package[`${prefix}wdefectsteps`]})},
              {[`${prefix}wqualitysteps`]: getWBObjects({type: `${prefix}wqualitysteps`, ids: work_package[`${prefix}wqualitysteps`]})},
              {[`${prefix}whandoversteps`]: getWBObjects({type: `${prefix}whandoversteps`, ids: work_package[`${prefix}whandoversteps`]})},
              {[`${prefix}wdesignsteps`]: getWBObjects({type: `${prefix}wdesignsteps`, ids: work_package[`${prefix}wdesignsteps`]})},
              {[`${prefix}wlogisticsteps`]: getWBObjects({type: `${prefix}wlogisticsteps`, ids: work_package[`${prefix}wlogisticsteps`]})},
              {[`${prefix}wmaterialsteps`]: getWBObjects({type: `${prefix}wmaterialsteps`, ids: work_package[`${prefix}wmaterialsteps`]})},
              {[`${prefix}wmachinesteps`]: getWBObjects({type: `${prefix}wmachinesteps`, ids: work_package[`${prefix}wmachinesteps`]})},
            ),
            selector: 'parent'
          }).then((payload) => {
              createUObject(payload).then((id) => {
                $router.push({
                  name: 'TaktPlanWorkPackageEdit',
                  params: {
                    tworkpackage_id: id,
                    }
                  });
                })
            })"
          >
          <!-- @click="tWorkPackageInsert({
            project_id: project_id,
            train_id: train_id,
            taktarea_id: taktarea_id,
            twaggon_id: twaggon_id,
            work_package: Object.assign(
            work_package,
            {[`${prefix}wworksteps`]: getWBObjects({type: `${prefix}wworksteps`, ids: work_package[`${prefix}wworksteps`]})},
            {[`${prefix}wdefectsteps`]: getWBObjects({type: `${prefix}wdefectsteps`, ids: work_package[`${prefix}wdefectsteps`]})},
            {[`${prefix}wqualitysteps`]: getWBObjects({type: `${prefix}wqualitysteps`, ids: work_package[`${prefix}wqualitysteps`]})},
            {[`${prefix}whandoversteps`]: getWBObjects({type: `${prefix}whandoversteps`, ids: work_package[`${prefix}whandoversteps`]})},
            {[`${prefix}wdesignsteps`]: getWBObjects({type: `${prefix}wdesignsteps`, ids: work_package[`${prefix}wdesignsteps`]})},
            {[`${prefix}wlogisticsteps`]: getWBObjects({type: `${prefix}wlogisticsteps`, ids: work_package[`${prefix}wlogisticsteps`]})},
            ),
            snack_bar: { bulk: false }
          })" -->
          <v-icon class="mr-1">add</v-icon>
          {{$t('Buttons.Add')}}
        </v-btn>
        <v-btn
          @click="$router.push({
            name: 'TaktPlanAddWorkPackageDetailsEditEditor'
            })"
          >
          <v-icon class="mr-1">edit</v-icon>
          {{$t('Buttons.Edit')}}
        </v-btn>
        <transition
          name="dialog_slide"
          >
          <router-view/>
        </transition>
    </template>
    <template #body-content>
      <WaggonInfoHeader
        :color="work_package.color"
        :text="work_package.token"
        :icon="work_package.icon"
        :textcolor="work_package.textcolor"
      />
      <StandardDataField
        :value="work_package.name"
        :text_color="work_package.textcolor"
        readonly="true"
        />
      <StandardDataField
        :value="work_package.description"
        :text_color="work_package.textcolor"
        flat="true"
        :placeholder="$t('Project.Workpackage.Info.DescriptionPlaceholder')"
        :resizable="true"
        :readonly="true"
        />
      <v-divider color="black"></v-divider>
      {{$t('Project.Workpackage.Info.Attributes')}}
      <StandardFlexBox>
      <StandardDataField
        :text_color="work_package.textcolor"
        :value="work_package.time_effort_planned"
        icon="speed"
        width="33%"
        :type="'number'"
        :readonly="true"
        />
      <StandardDataField
        :text_color="work_package.textcolor"
        :value="work_package.manpower_planned"
        icon="accessibility"
        width="33%"
        :type="'number'"
        :readonly="true"
        />
      <StandardDataField
        :text_color="work_package.textcolor"
        :value="Math.round((work_package.time_effort_planned/work_package.manpower_planned)*100) / 100"
        icon="timer"
        width="33%"
        :type="'number'"
        :readonly="true"
        />
      </StandardFlexBox>
      <StandardFlexBox>
      <StandardDataField
        :text_color="work_package.textcolor"
        :value="work_package.quantity_value"
        icon="drag_indicator"
        width="33%"
        :type="'number'"
        :readonly="true"
        />
      <StandardDataField
        :text_color="work_package.textcolor"
        :value="work_package.quantity_unit"
        icon="drag_indicator"
        width="33%"
        :readonly="true"
        />
      </StandardFlexBox>
      <template v-for="type in ['work', 'defect', 'quality', 'handover', 'design', 'logistic', 'material']">
        <v-divider color="black" :key="`${type}divider`"/>
        {{type}}{{$t('Project.Workpackage.Steps.TypeAdditive')}} ({{work_package[`${prefix}w${type}steps`].length}})
        <StandardStep
          v-for="step in getWBObjects({type: `${prefix}w${type}steps`, ids: work_package[`${prefix}w${type}steps`]})"
          :key="`${type}step${step.id}`"
          :step="step"
          :step_type="`${type}steps`"
          :readonly="true"
        />
      </template>
      <v-divider color="black"></v-divider>
      <div class="mt-1">
        @
        {{work_package.owner.first_name}}
        {{work_package.owner.last_name}}
      </div>
      <div>{{work_package.created.substring(0, 19)}}</div>
    </template>
  </WaggonInfoBody>
</template>
<script>
import { WaggonInfoAddMixin } from '@/mixins/WaggonInfoAdd.mixin.js'

export default {
  props: [
    'prefix',
    'project_id',
    'train_id',
    'taktarea_id',
    'twaggon_id',
    'work_package',
    'backlog',
  ],
  mixins: [
    WaggonInfoAddMixin
  ],
}
</script>
